import { SITE } from '@/app/constants';

export const IMG_CONFIG_CHINA = [
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image13-0bff0a93.webp',
    title: 'title13',
    description: 'description13',
    position: 'top-[8%] left-[6%] h-[25.5%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image1-65c70b29.webp',
    title: 'title1',
    description: 'description1',
    position: 'bottom-[13%] right-[2%] h-[16.8%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image2-2bd38261.webp',
    title: 'title2',
    description: 'description12',
    position: 'top-[65%] left-[-1%] h-[26.7%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image3-2365f902.webp',
    title: 'title3',
    description: 'description4',
    position: 'bottom-[40%] right-[5%] h-[35.5%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image5-026301b6.webp',
    title: 'title5',
    description: 'description5',
    position: 'bottom-[20%] left-[23%] h-[21.2%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image9-7780b44b.webp',
    title: 'title9',
    description: 'description6',
    position: 'top-[30%] left-[1%] h-[15%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image7-ad3b6592.webp',
    title: 'title7',
    description: 'description7',
    position: 'bottom-[22%] right-[22%] h-[22.6%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image15-e2b3524a.webp',
    title: 'title15',
    description: 'description15',
    position: 'top-[49%] right-[-4%] h-[19%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image11-983b87c9.webp',
    title: 'title11',
    description: 'description11',
    position: 'top-[25%] left-[17%] h-[29%]',
  },

  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image16-35737a25.webp',
    title: 'title16',
    description: 'description16',
    position: 'top-[50%] left-[-2%] h-[5.3%]',
  },
];

export const IMG_CONFIG_GLOBAL = [
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image13-0bff0a93.webp',
    title: 'global_title13',
    description: 'description13',
    position: 'top-[8%] left-[6%] h-[25.5%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image1-65c70b29.webp',
    title: 'global_title1',
    description: 'description1',
    position: 'bottom-[13%] right-[2%] h-[16.8%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image12-e3bc56cf.webp',
    title: 'global_title12',
    description: 'description12',
    position: 'top-[65%] left-[-1%] h-[26.7%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image4-6d819a23.webp',
    title: 'global_title4',
    description: 'description4',
    position: 'bottom-[40%] right-[5%] h-[35.5%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image6-a7a59ef3.webp',
    title: 'global_title5',
    description: 'description5',
    position: 'bottom-[20%] left-[23%] h-[21.2%]',
  },
  {
    image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/image8-4f0a80ae.webp',
    title: 'global_title8',
    description: 'description8',
    position: 'bottom-[22%] right-[22%] h-[22.6%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image10-2d33c11e.webp',
    title: 'global_title10',
    description: 'description10',
    position: 'top-[30%] left-[1%] h-[15%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image11-983b87c9.webp',
    title: 'global_title11',
    description: 'description11',
    position: 'top-[25%] left-[17%] h-[29%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image15-e2b3524a.webp',
    title: 'global_title15',
    description: 'description15',
    position: 'top-[49%] right-[-4%] h-[19%]',
  },
  {
    image: 'https://image01.cf.vidu.studio/vidu/media-asset/image14-067142d0.webp',
    title: 'global_title14',
    description: 'description14',
    position: 'top-[50%] left-[-2%] h-[5.3%]',
  },
];

export const IMG_CONFIG = SITE === 'china' ? IMG_CONFIG_CHINA : IMG_CONFIG_GLOBAL;

export const MB_IMG_CONFIG =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/whyVidu1-4b897664.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/whyVidu1-4b897664.webp';
